import BaseService from "./Base.Service";

class ApiKeysService extends BaseService {
  constructor() {
    super("api-keys");
  }

  async generate({ name, scope = "read", expiresInDays = null }) {
    try {
      const { data } = await this.conn.axios.post("/api-keys", {
        name,
        scope,
        expiresInDays,
      });
      return data;
    } catch (err) {
      return this.sendError("Erro ao gerar a chave", false, err);
    }
  }

  async rotate(id) {
    try {
      const { data } = await this.conn.axios.post(`/api-keys/${id}/rotate`);
      return data;
    } catch (err) {
      return this.sendError("Erro ao rotacionar a chave", false, err);
    }
  }

  async revoke(id) {
    try {
      const { data } = await this.conn.axios.post(`/api-keys/${id}/revoke`);
      return data;
    } catch (err) {
      return this.sendError("Erro ao revogar a chave", false, err);
    }
  }
}

export default ApiKeysService;
